import { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'
import { useOnboardingStore } from '@/store/onboardingStore'
import { getProfile } from '@/services/profileService'
import { needsOnboarding } from '@/lib/onboarding'

// ครอบทั้งแอป — บัญชีบริษัทที่ข้อมูลยังไม่ครบเข้าได้แค่ /onboarding หน้าเดียว
// path อื่นทุกหน้า (พิมพ์ URL เอง, กด back, ลิงก์ใน Navbar) จะถูกส่งกลับมาที่ /onboarding
// บุคคลทั่วไปและบริษัทที่กรอกครบแล้วผ่านได้ตามปกติ
export default function OnboardingGate({ children }: { children: React.ReactNode }) {
  const isLoggedIn = useAuthStore((s) => s.isLoggedIn)
  const customerType = useAuthStore((s) => s.customerType)
  const customerId = useAuthStore((s) => s.customerId)
  const status = useOnboardingStore((s) => (s.customerId === customerId ? s.status : 'unknown'))
  const setStatus = useOnboardingStore((s) => s.set)
  const reset = useOnboardingStore((s) => s.reset)
  const location = useLocation()

  const isCompany = isLoggedIn && customerType === 'COMPANY' && customerId != null

  useEffect(() => {
    if (!isCompany) { reset(); return }
    if (status !== 'unknown') return
    let cancelled = false
    getProfile()
      .then((p) => { if (!cancelled) setStatus(customerId!, needsOnboarding(p) ? 'incomplete' : 'complete') })
      // โหลดโปรไฟล์ไม่สำเร็จ — ไม่บล็อกการใช้งาน (backend ยังกันโพสต์งานตอนข้อมูลไม่ครบไว้อีกชั้น)
      .catch(() => { if (!cancelled) setStatus(customerId!, 'complete') })
    return () => { cancelled = true }
  }, [isCompany, customerId, status, setStatus, reset])

  if (!isCompany) return <>{children}</>
  if (status === 'unknown') return null // รอเช็คก่อน กันหน้าอื่นแวบขึ้นมา

  const onOnboardingPage = location.pathname === '/onboarding'
  if (status === 'incomplete' && !onOnboardingPage) {
    return <Navigate to="/onboarding" replace state={{ from: location.pathname }} />
  }
  return <>{children}</>
}
